import React from "react";
import { Box, Container, Grid, Typography } from "@mui/material";

const KalpavrukshaVaibhava = () => {
  return (
    <Box sx={{ py: 8, backgroundColor: "#fafafa" }}>
      <Container
        sx={{
          maxWidth: "1200px !important",
          mx: "auto",
        }}
      >
        {/* ---------- KALPAVRUKSHA GREEN ---------- */}
        <Grid
          container
          spacing={4}
          alignItems="center"
          sx={{
            mb: 8,
            flexDirection: { xs: "column", md: "row" },
          }}
        >
          {/* Left Content */}
          <Grid item xs={12} md={6}>
            <Typography
              variant="h4"
              sx={{
                fontWeight: 800,
                color: "#006769",
                mb: 2,
                fontSize: { xs: "26px", md: "48px" },
              }}
            >
              KALPAVRUKSHA GREEN
            </Typography>
            <Typography
              sx={{
                color: "#555",
                fontSize: { xs: "15px", md: "22px" },
                lineHeight: "36px",
                textAlign: "justify",
              }}
            >
              With the rapid development in the area, North Bangalore has become
              a prime zone and is in high demand. Having the Bangalore
              International Airport in the north zone and other major Government
              offices like the DC (District Collector) office, government
              proposals for ITIR are contributing to this rapid growth. If you
              want to buy a plot of land, now is the time. By the end of 2023,
              the ROI could be as high as 250%.
            </Typography>
          </Grid>

          {/* Right Map */}
          <Grid item xs={12} md={6}>
            <Box
              sx={{
                width: "100%",
                height: "400px",
                borderRadius: 2,
                overflow: "hidden",
                boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
              }}
            >
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m13!1m8!1m3!1d26015.580646472165!2d77.740611!3d13.217139!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTPCsDEzJzAxLjciTiA3N8KwNDQnMjYuMiJF!5e1!3m2!1sen!2sus!4v1761727234420!5m2!1sen!2sus"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Kalpavruksha Green Map"
              ></iframe>
            </Box>
          </Grid>
        </Grid>

        {/* ---------- VAIBHAVA GREENS ---------- */}
        <Grid container spacing={4} alignItems="center">
          <Grid item xs={12} md={10} textAlign="center" mx="auto">
            <Typography
              variant="h4"
              sx={{
                fontWeight: 800,
                color: "#006769",
                mb: 2,
                fontSize: { xs: "26px", md: "48px" },
              }}
            >
              VAIBHAVA GREENS
            </Typography>

            <Typography
              sx={{
                color: "#555",
                fontSize: { xs: "15px", md: "28px" },
                lineHeight: "42px",
                textAlign: "center", // overrides previous "justify"
              }}
            >
              With the rapid development in the area, North Bangalore has become
              a prime zone and is in high demand. Having the Bangalore
              International Airport in the north zone and other major Government
              offices like the DC (District Collector) office, government
              proposals for ITIR are contributing to this rapid growth. If you
              want to buy a plot of land, now is the time. By the end of 2023,
              the ROI could be as high as 250%.
            </Typography>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default KalpavrukshaVaibhava;
